import React, { useEffect, useState } from "react";
import { Breadcrumb } from "components";
import MaterialTable from "material-table";
import { Spinner } from "reactstrap";
import { tableIcons } from "pages/importSales";
import { getUserNotifications } from "service/notificationsService";
import FileViewerModel from "components/fileViewer";
import NotificationBody from "pages/notifications/NotificationBody";
import { formatDate } from "utils/date";
import { useLocation } from "react-router-dom";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

const UserNotifications = ({ category, title }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(false);

  let query = useQuery();

  const id = query.get("id");

  // console.log(`UserNotification ${category}`, )

  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    getUserNotifications(category)
      .then((res) => {
        const resData = res.data || {};
        setData(resData);
        if (id) {
          handleSelected(resData || []);
        }
      })
      .catch(() => {})
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSelected = (data = []) => {
    let selected = data.filter((item) => item.id == id);
    // console.log("UserNotification handleSelected", selected);

    if (selected.length) {
      setSelected(selected[0]);
    }
  };

  const contentData = data;

  const renderLoading = () => (
    <div className="d-flex justify-content-center mt-5 pt-5">
      <Spinner />
    </div>
  );

  const renderNoData = () => (
    <div className="d-flex justify-content-center mt-5 pt-5">
      <div>Don't have data!</div>
    </div>
  );

  return (
    <>
      <Breadcrumb title={title} />
      <div className="app-wrapper">
        <div className="animated slideInUpTiny animation-duration-3">
          <div className="row">
            <div className="col-12 mb-4">
              {!contentData.length && !loading ? renderNoData() : null}
              {!contentData.length && loading ? renderLoading() : null}

              {contentData.length ? (
                <MaterialTable
                  title=""
                  icons={tableIcons}
                  columns={[
                    {
                      title: "",
                      field: "file_link",
                      render: (rowData) => (
                        <FileViewerModel
                          isAdmin={false}
                          subject={rowData.subject}
                          file_type={rowData.file_type}
                          file_link={rowData.file_link}
                        />
                      ),
                    },
                    { title: "Subject", field: "subject" },
                    {
                      title: "Body",
                      field: "body",
                      render: (rowData) => (
                        <NotificationBody isAdmin={false} data={rowData} />
                      ),
                    },
                    {
                      title: "Date",
                      field: "date",
                      render: (rowData) => formatDate(rowData.created),
                    },
                  ]}
                  data={contentData}
                  options={{
                    actionsColumnIndex: -1,
                  }}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
      <NotificationBody
        onClose={() => {
          setSelected(false);
        }}
        open={!!selected}
        isAdmin={false}
        data={selected}
      />
    </>
  );
};

export default UserNotifications;
